'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lib = require('helpers/lib');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _staticStar3x = require('assets/img/staticStar@3x.png');

var _staticStar3x2 = _interopRequireDefault(_staticStar3x);

var _bigLogo13x = require('assets/img/bigLogo1@3x.png');

var _bigLogo13x2 = _interopRequireDefault(_bigLogo13x);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkPartnerMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appLink: state.setup.appLink
  };
}, (0, _extends3.default)({}, setupActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LinkPartnerMobile, _Component);

  function LinkPartnerMobile() {
    (0, _classCallCheck3.default)(this, LinkPartnerMobile);
    return (0, _possibleConstructorReturn3.default)(this, (LinkPartnerMobile.__proto__ || (0, _getPrototypeOf2.default)(LinkPartnerMobile)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinkPartnerMobile, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.props.params.code) {
                  _context.next = 9;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this.props.loadDynamicLink('kol', this.props.params.code);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                this.props.loadDynamicLink('page', 'uu-dai');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./LinkPartnerMobile.scss');
      var appLink = this.props.appLink;

      var linkDownload = void 0;
      var linkAndroid = void 0;
      var linkIos = void 0;
      if ((0, _lib.detectIos)()) {
        linkDownload = _config2.default.iosLink;
      } else if ((0, _lib.detectAndroid)()) {
        linkDownload = _config2.default.androidLink;
      } else {
        linkAndroid = _config2.default.androidLink;
        linkIos = _config2.default.iosLink;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement('img', { src: _staticStar3x2.default, className: styles.star1 }),
        _react2.default.createElement('img', { src: _staticStar3x2.default, className: styles.star2 }),
        _react2.default.createElement('img', { src: _staticStar3x2.default, className: styles.star3 }),
        _react2.default.createElement('img', { src: _staticStar3x2.default, className: styles.star4 }),
        _react2.default.createElement(
          'div',
          { className: styles.contentView },
          _react2.default.createElement('img', { src: _bigLogo13x2.default, className: styles.bigLogo }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '\u0110\u1EB7t l\u1ECBch, \u01B0u \u0111\xE3i & \u0110\xE1nh gi\xE1 \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.stepView },
            _react2.default.createElement(
              'div',
              { className: styles.clickView },
              _react2.default.createElement(
                'div',
                { className: styles.step },
                'B\u01AF\u1EDAC 1: T\u1EA3i app Lookme. '
              ),
              linkDownload ? _react2.default.createElement(
                'a',
                {
                  href: linkDownload,
                  className: styles.clickText,
                  target: '_blank'
                },
                'T\u1EA1i \u0111\xE2y.'
              ) : _react2.default.createElement(
                'div',
                { style: { flexDirection: 'row' } },
                _react2.default.createElement(
                  'a',
                  {
                    href: linkIos,
                    className: styles.clickText,
                    target: '_blank'
                  },
                  'iOS'
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.middleText },
                  'ho\u1EB7c'
                ),
                _react2.default.createElement(
                  'a',
                  {
                    href: linkAndroid,
                    className: styles.clickText,
                    target: '_blank'
                  },
                  'Android'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.step },
              'B\u01AF\u1EDAC 2: T\u1EA1o t\xE0i kho\u1EA3n ho\u1EB7c \u0111\u0103ng nh\u1EADp'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.step },
              'B\u01AF\u1EDAC 3: B\u1EA5m n\xFAt d\u01B0\u1EDBi \u0111\u1EC3 l\u1EA5y \u01B0u \u0111\xE3i'
            )
          ),
          _react2.default.createElement(
            'a',
            { href: appLink, target: '_blank' },
            _react2.default.createElement(
              'div',
              { className: styles.voucherButtonTemp },
              _react2.default.createElement(
                'div',
                { className: styles.voucherButtonText },
                'L\u1EA5y Voucher'
              )
            )
          )
        )
      );
    }
  }]);
  return LinkPartnerMobile;
}(_react.Component), _class2.propTypes = {
  appLink: _react.PropTypes.string,
  loadDynamicLink: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class);
exports.default = LinkPartnerMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/LinkPartner/LinkPartnerMobile.js
// module id = 1610
// module chunks = 0